<template>
  <header id="header" :class="isScrolled ? 'navbar' : 'navbar-start'">
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <div
            class="d-flex align-center my-auto"
            style="cursor: pointer"
            @click="scrollToElement('header')"
          >
            <v-img
              v-if="isScrolled"
              alt="Central lab logo"
              class="shrink"
              contain
              min-width="145"
              src="../../assets/png/Logo_Orange.png"
              width="145"
            />
          </div>

          <v-spacer />
          <v-menu v-if="isMobile" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                :class="isScrolled ? 'navbar-color' : 'navbar-color-start'"
                v-on="on"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-hover
                v-for="link in text.links"
                v-slot:default="{ hover }"
                :key="link.name"
              >
                <v-list-item
                  :class="{ 'selected-row': hover }"
                  class="my-auto link px-5"
                  @click="
                    () => {
                      link.type
                        ? openAppointmentWindow()
                        : scrollToElement(link.element);
                    }
                  "
                >
                  <v-list-item-title>{{ link.name }}</v-list-item-title>
                </v-list-item>
              </v-hover>
            </v-list>
          </v-menu>
          <div v-else>
            <v-btn
              v-for="link in text.links"
              :key="link.name"
              class="my-auto link px-3"
              :text="!link.type || !isScrolled"
              :depressed="link.type !== null"
              :class="{
                'navbar-color-action': link.type && isScrolled,
                'navbar-color': isScrolled,
                'navbar-color-start': !isScrolled,
              }"
              @click="
                () => {
                  link.type
                    ? openAppointmentWindow()
                    : scrollToElement(link.element);
                }
              "
            >
              <span>{{ link.name }}</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </header>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "App",

  props: {
    scroll: {
      type: Number,
      required: true,
    },
    openAppointmentWindow: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    text: lang.appbar,
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isScrolled() {
      return this.scroll !== 0;
    },
  },

  methods: {
    scrollToElement(element, offset = 0) {
      this.$scrollTo(`#${element}`, 500, { offset: -92 + offset });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.link {
  font-family: "Roboto";
  text-transform: none;
  color: map-get($theme-colors, "dark-blue") !important;
  font-size: 14px;
  font-weight: normal !important;
}

.navbar {
  background-color: white;
  position: fixed;
  width: 100%;
  z-index: 10;
}

.navbar-start {
  background-color: transparent;
  position: fixed;
  width: 100%;
  z-index: 10;
}

.navbar-color {
  color: map-get($theme-colors, "dark-blue") !important;
}

.navbar-color-start {
  color: white !important;
}

.navbar-color-action {
  background: map-get($theme-colors, "backgroundpartnership") !important;
  color: white !important;
}

.selected-row {
  background: #eef4f9;
}
</style>
